export default class DadosPrincipal {
  constructor () {
    this.identificacaoFiscal = null
    this.matricula = null
    this.dataNascimento = null
    this.telefone = null
    this.email = null
  }
}
